import * as React from "react"
import "./selected-image-status.css"
import { GenericUpload, LoadingErrorMaybe } from "@nova/constants"
import { useTranslation } from "@nova/use-translation"
import { trimMiddle } from "@nova/util-strings"
import { useMemo } from "react"
import { DateFormat, formatDateRange, TimeFormat } from "@nova/format"
import { dateFromNumber } from "@nova/serializer/src/client/util"
export { imageProcessingPresentation } from "./image-processing"

type SelectedImageStatusProps = {
    selected: LoadingErrorMaybe<GenericUpload>[]
    uploads: LoadingErrorMaybe<GenericUpload>[]
    dateFormat: DateFormat
    timeFormat: TimeFormat
}

export const SelectedImageStatus = ({
    selected,
    uploads,
    dateFormat,
    timeFormat,
}: SelectedImageStatusProps) => {
    const { t } = useTranslation()
    const totalUploads = uploads.length
    const [minDate, maxDate] = useMemo(() => {
        const uploadsWithTime = (
            uploads.filter((e) => !("loading" in e) && !("error" in e)) as GenericUpload[]
        )
            .map((e) => (e.takenAt ? new Date(dateFromNumber(e.takenAt)) : null))
            .filter((e) => e) as Date[]
        if (!uploadsWithTime || uploadsWithTime.length === 0) return ["", ""]
        const minDate = uploadsWithTime.reduce((min, current) => (current < min ? current : min))
        const maxDate = uploadsWithTime.reduce((max, current) => (current > max ? current : max))
        const formattedDate = formatDateRange({
            value: { start: minDate, end: maxDate },
            dateFormat: dateFormat,
            timeFormat: timeFormat,
        })
        return [formattedDate.split(" -")[0], formattedDate.split("- ")[1]]
    }, [uploads, dateFormat, timeFormat])
    let selectionMessage = ""
    let fileName = ""
    if (selected.length === 0) {
        selectionMessage = `${totalUploads} file` + (totalUploads !== 1 ? "s" : "")
    } else if (selected.length === 1) {
        fileName = "name" in selected[0] && selected[0].name ? selected[0].name : selected[0].id
        selectionMessage = `${selected.length} of ${totalUploads} files`
    } else {
        selectionMessage = `${selected.length} of ${totalUploads} files`
    }
    return (
        <>
            {minDate && maxDate && (
                <div className="flex gap-1 flex-wrap">
                    <div className="selected-image-status__container selected-image-status__name">
                        {t(minDate || "")}
                    </div>
                    <div className="selected-image-status__container py-[6px]">{t("-")}</div>
                    <div className="selected-image-status__container selected-image-status__name">
                        {t(maxDate)}
                    </div>
                </div>
            )}
            <div className="flex gap-1 flex-wrap">
                <div className="selected-image-status__container selected-image-status__name">
                    {t(
                        trimMiddle(selectionMessage, {
                            maxLength: 37,
                            separator: "...",
                            distribution: 0.22,
                        })
                    )}
                </div>
                {fileName && (
                    <div className="selected-image-status__container selected-image-status__name">
                        {t(
                            trimMiddle(fileName, {
                                maxLength: 37,
                                separator: "...",
                                distribution: 0.22,
                            })
                        )}
                    </div>
                )}
            </div>
        </>
    )
}
